import React from 'react';
import './App.css';
import { Provider as StoreProvider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { SnackbarProvider } from 'notistack';
import { PersistGate } from 'redux-persist/integration/react';
import { configureStore } from './store';
import Main from './Main';
import { NotificationToaster } from 'CommonComponent';


const store = configureStore();
const persistor = persistStore(store);

const App =() => {
  return (
    <StoreProvider store={store}>
      <PersistGate persistor={persistor} >
        <SnackbarProvider anchorOrigin={{ horizontal: 'right', vertical: 'top' }}>
          <NotificationToaster/>
          <Main/>
        </SnackbarProvider> 
      </PersistGate>
    </StoreProvider>
  );
}

export default App;
